/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Soft_Tiger_LandInputs */

const en_bold_soft_tiger_land = /** @type {(inputs: Bold_Soft_Tiger_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New survey round`)
};

const de_bold_soft_tiger_land = /** @type {(inputs: Bold_Soft_Tiger_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Befragungsrunde`)
};

/**
* | output |
* | --- |
* | "New survey round" |
*
* @param {Bold_Soft_Tiger_LandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_soft_tiger_land = /** @type {((inputs?: Bold_Soft_Tiger_LandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Soft_Tiger_LandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_soft_tiger_land(inputs)
	return de_bold_soft_tiger_land(inputs)
});